import React from 'react';

import {PageMenu} from '../components/PageMenu';

export const FaqPage: React.FC = () => (
  <main>
    <PageMenu active="/faq" />

    <section className="py-8">
      <div className="mx-auto max-w-screen-xl px-4">
        <h1 className="mb-5 text-2xl font-light md:text-3xl">よくあるご質問</h1>

        <section className="mb-8">
          <h4 className="mb-2 text-base">Q1. 事前に見学はできますか？</h4>
          <ul>
            <li className="text-sm leading-relaxed text-gray-600 md:text-base md:leading-loose">
              講義の一般見学はできませんが、教室の雰囲気を見ていただくことは可能です。
            </li>
          </ul>
        </section>
      </div>
    </section>
  </main>
);
